import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Fade from 'react-reveal/Fade'

import ContentHolder from '../../ui/ContentHolder'

import styles from './styles.scss'

const renderText = (text) => {
  if (text){
    return typeof text === 'object' ? (
      <span className={styles.text}>{text}</span>
    ) : (
      <p className={styles.text}>{text}</p>
    )
  }

  return null
}

const TextOnly = (props) => {
  const { dark, title, text } = props

  return (
    <div className={dark ? classnames(styles.root, styles.dark) : styles.root}>
      <ContentHolder>
        <Fade>
          <span>
            <h3 className={styles.title}>{title}</h3>
            {renderText(text)}
          </span>
        </Fade>
      </ContentHolder>
    </div>
  )
}

TextOnly.propTypes = {
  dark: PropTypes.bool,
  title: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
}

export default TextOnly
